import { PropsWithChildren } from "react";
import styled from "styled-components";
import {
  elevation00,
  shade0,
  shade300,
  shade700,
  shade900,
} from "../../styles/tokens";
import { IconButton } from "../icon-button/IconButton.Parts";

// TEXT

// STYLES
export const Input = styled.input`
  margin: 0;
  z-index: 1;
  height: 3.5rem;
  direction: rtl;
  appearance: none;
  padding: 1.5rem 0;
  box-sizing: content-box;
  writing-mode: vertical-lr;

  &::-webkit-slider-runnable-track {
    cursor: pointer;
    width: 0.375rem;
    appearance: none;
  }

  &::-webkit-slider-thumb {
    z-index: 3;
    width: 1rem;
    height: 1rem;
    cursor: pointer;
    appearance: none;
    position: relative;
    transform: scale(0);
    border-radius: 1.5rem;
    transition: 0.2s transform;
    translate: calc(-50% + 0.1875rem) 0;

    box-shadow: ${elevation00};
    background-color: ${shade0};
    border: 1px solid ${shade300};
  }

  &:hover::-webkit-slider-thumb,
  &:focus::-webkit-slider-thumb {
    transform: scale(1);
  }
`;

export const Control = styled.div`
  width: 3rem;
  display: none;
  bottom: 1.5rem;
  height: 6.5rem;
  position: absolute;
  justify-content: center;
  border-radius: 3rem 3rem 0 0;

  opacity: 0;
  transition:
    opacity 0.3s,
    display 0.4s ease-out allow-discrete;

  background-color: ${shade900};
`;

export const Level = styled.div<{ $volume: number }>`
  --volume: ${({ $volume }) => $volume / 100};

  left: 50%;
  height: 3.5rem;
  bottom: 1.5rem;
  width: 0.375rem;
  overflow: hidden;
  translate: -50% 0;
  position: absolute;
  border-radius: 0.5rem;
  box-sizing: content-box;
  background-color: color-mix(in srgb, ${shade700}, transparent 70%);

  &::before {
    left: 50%;
    content: "";
    bottom: -1rem;
    width: 0.375rem;
    translate: -50% 0;
    position: absolute;
    transition: 0.2s all;
    pointer-events: none;
    border-radius: 0.5rem 0.5rem 0 0;

    background-color: ${shade0};
    height: calc(1rem + (3.5rem * var(--volume)));
  }
`;

export const Wrapper = styled.div`
  display: flex;
  position: relative;

  &:has(${Control}:hover),
  &:has(${IconButton}:hover) {
    ${Control} {
      opacity: 1;
      display: flex;

      @starting-style {
        opacity: 0;
        background-color: red;
      }
    }

    ${IconButton} svg {
      color: ${shade0};
    }
  }

  &:has(${Input}:hover) ${Level}::before {
    transition: none;
  }
`;

// DATA

// TYPES
export interface Props extends PropsWithChildren {
  volume?: number;
  onChange: (value: number) => void;
}

// CONSTANTS

// FUNCTIONS

// ASSETS
